export default __webpack_public_path__ + "static/media/tapaOtono22_4.928886a5.jpg";